export default {
      id: "centralchurch-text-usage",
      viewBox: "0 0 260 145",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#centralchurch-text",
      toString: function () {
        return this.url;
      }
    }